(() => {
  function init(root = document) {
    root.querySelectorAll('[data-pure-calculator]').forEach(section => {
      if (section.dataset.pureReady) return;
      section.dataset.pureReady = 'true';
      const plants = section.querySelector('[data-pure-plants]');
      const spares = section.querySelector('[data-pure-spares]');
      const size = Number(section.dataset.caseSize);
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en');
      const result = section.querySelector('.pure-calc__result');
      const error = section.querySelector('[data-pure-error]');
      const update = () => {
        const count = Number(plants.value), allowance = Number(spares.value);
        const valid = plants.value !== '' && spares.value !== '' && Number.isInteger(count) && count >= 1 && count <= 1000000 && Number.isFinite(allowance) && allowance >= 0 && allowance <= 100 && Number.isInteger(size) && size > 0;
        error.hidden = valid;
        result.hidden = !valid;
        if (!valid) return;
        const needed = Math.ceil(count * (100 + allowance) / 100);
        const cases = Math.ceil(needed / size);
        section.querySelector('[data-pure-cases]').textContent = formatter.format(cases);
        section.querySelector('[data-pure-bags]').textContent = formatter.format(cases * size);
        section.querySelector('[data-pure-extra]').textContent = formatter.format(cases * size - count);
      };
      plants.addEventListener('input', update);
      spares.addEventListener('input', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target.parentElement || document));
})();
